import Main from './Main'
import FormaPagamento from './diarias/forma-pagamento/routes'
import Policiais from './policiais/routes'
import Justificativa from './diarias/justificativa/routes'
import RouboFurto from './roubo-furto/routes'
import Notificacao from './notificacao/situacao-aviso-recebimento/routes'
import CadastroPublico from './cadastro-publico/routes'
import Processos from './processo/routes'
import Sistema from './sistema/routes'
import Veiculo from './veiculo/routes'

export default [
  {
    path: '/policia-civil',
    component: Main,
    name: 'policia.civil',
    children: [
      ...FormaPagamento,
      ...Justificativa,
      ...Notificacao,
      ...Policiais,
      ...RouboFurto,
      ...CadastroPublico,
      ...Processos,
      ...Sistema,
      ...Veiculo
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/routes.js